/**
 * The base intro.js options to be shared.
 * See: https://introjs.com/docs/intro/options/ for more values.
 *
 * Custom values we should preface with `novus` to avoid potential collisions.
 *
 * @param {Function} t The function to perform translations with (see `getTranslateFunction()`).
 * @return {object} The default options to use.
 */
export const baseOptions = (t) => {
  return {
    steps: [],
    exitOnEsc: true,
    exitOnOverlayClick: false,
    keyboardNavigation: true,
    showStepNumbers: false,
    scrollTo: 'tooltip',
    /**
     * Disabled. See: https://github.com/usablica/intro.js/issues/109
     * and: OnboardingTour.style.js
     */
    overlayOpacity: 0,
    nextLabel: t('Next'),
    prevLabel: t('Previous'),
    skipLabel: t('Skip'),
    doneLabel: t('Done'),
    /**
     * This will be swapped into the 'doneLabel' at run time.
     */
    novusNextPageLabel: t('Continue')
  };
};



// WEBPACK FOOTER //
// ./src/actions/onboarding/config/baseOptions.js